import * as types from '../mutation-types'
import admin from '@/api/admin'

const state = {
  events: {}
}

const getters = {
  events: (state) => {
    return state.events
  }
}

const actions = {
  getEvents ({ commit, state }, route) {
    return new Promise((resolve, reject) => {
      admin.getEvents(route).then((response) => {
        let events = response.data.result.events
        events = events.slice().sort((a, b) => a.name.localeCompare(b.name))
        commit(types.ADD_EVENTS, events)
        resolve()
      }, (error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  [types.ADD_EVENTS] (state, events) {
    state.events = events
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
